import * as types from "./types";
import {
    postAdminAxios,
    getUserListAxios,
} from "./services";


  export async function postAdminAction({ commit }, payload) {
    commit(types.LOADING_ELEARN, true);
    try {
      const { data} = await postAdminAxios(payload);
      commit(types.POST_ADMIN, payload);
      return data;
    } catch (e) {
      throw e;
    } finally {
      commit(types.LOADING_ELEARN, false);
    }
  }

  export async function getUserListAction({commit}, tenantId) {
      commit(types.LOADING_ELEARN, true);
      try {
          const {data} = await getUserListAxios(tenantId);
          commit(types.GET_USER, data);
          return data;
      }
      catch(e) {
          throw e;
      }
      finally {
          commit(types.LOADING_ELEARN, false);
      }
  }